<template>
  
  <div id="app">
    <router-view></router-view>
  </div>

</template>

<script>
export default {
  name: 'app',
  methods:{
    fetchData() {
      //公共分享
        if(window.timer){
			clearInterval(window.timer)
		} 
		if(window.outTime){
			clearTimeout(window.outTime);
		}
    }
  },
  watch: {
    $route: "fetchData"
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
img{
  max-width: 100%;
}
#app {
  width: 100%;
  height: 100%;

}
</style>



// WEBPACK FOOTER //
// App.vue?26a3ad46